module.exports = __webpack_public_path__ + "img/center.e0e234d1.png";